"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var localized_strings_1 = require("localized-strings");
exports.densityUnits = new localized_strings_1.default({
    en: {
        PoundsPerGallon: {
            AbbreviatedDisplay: 'lbs/gal',
            FullDisplay: 'pounds per gallon'
        },
        SpecificGravity: {
            AbbreviatedDisplay: 'sg',
            FullDisplay: 'specific gravity'
        }
    },
    es: {
        PoundsPerGallon: {
            AbbreviatedDisplay: 'lbs/gal',
            FullDisplay: 'libras por galón'
        },
        SpecificGravity: {
            AbbreviatedDisplay: 'sg',
            FullDisplay: 'peso específico'
        }
    }
}, {
    logsEnabled: false
});
